import { render, staticRenderFns } from "./NewInfoRequest.vue?vue&type=template&id=874b6ad8"
import script from "./NewInfoRequest.vue?vue&type=script&lang=js"
export * from "./NewInfoRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports